import axios from 'axios'
import API from '@/services/API/api'

/**
 * Open the cash to start woring during the day.
 * @param {int} posCashDeskId Id of the cash that will be opened.
 * @param {int} cashierUserId  Id of the current casher logged in.
 * @param {int} initialAmountCash
 * @param {String} observation Comments or obervations (optional, could be void)
 */
const posDailyCash = async function(
    posCashDeskId,
    cashierUserId,
    initialAmountCash,
    observation
) {
    try {
        let response = await axios.post(API.DAILY_CASH, {
            pos_cash_desk_id: posCashDeskId,
            g_cashier_user_id: cashierUserId,
            initial_amount_cash: initialAmountCash,
            observation: observation,
        })

        return response.data
    } catch (error) {
        return error.response.data
    }
}

/**
 * Closes the actual session of the cash.
 * @param {*} posCashDeskId
 * @param {*} cashierUserId
 * @param {*} authCodeSupervisor
 * @param {*} realCashTotal
 * @param {*} observation
 */
const posDailyCashClose = async function(
    posCashDeskId,
    cashierUserId,
    authCodeSupervisor,
    realCashTotal,
    observation
) {
    try {
        let response = await axios.patch(API.DAILY_CLOSE, {
            pos_cash_desk_id: posCashDeskId,
            g_cashier_closure_user_id: cashierUserId,
            auth_code_supervisor: authCodeSupervisor,
            real_cash_total: realCashTotal,
            closure_observation: observation,
        })

        return response.data
    } catch (error) {
        return error.response.data
    }
}

const dailyInvoices = async function(cashId) {
    try {
        let response = await axios.get(API.DAILY_INVOICES, {
            params: {
                cash_desk_id: cashId,
            },
        })

        return response.data
    } catch (error) {
        return error.response.data
    }
}

/**
 * Registers a cash movement (egress or ingress of cash)
 * @param {*} posCashDeskId
 * @param {int} egress 1 if the movement is an egress, 0 if is an ingress
 * @param {int} ingress 1 if the movement is an ingress, 0 if is an egress
 * @param {*} userId ID of the cashier logged in
 * @param {*} amountCash Amount of cash moved from/to the cash.
 * @param {*} observation
 */
const posCashMovement = async function(
    posCashDeskId,
    egress,
    ingress,
    userId,
    amountCash,
    observation
) {
    try {
        let response = await axios.post(API.CASH_MOV, {
            pos_cash_desk_id: posCashDeskId,
            pos_cash_movement_egress_type_id: egress,
            pos_cash_movement_ingress_type_id: ingress,
            g_user_id: userId,
            amount: amountCash,
            observation: observation,
        })

        return response.data
    } catch (error) {
        return error.response.data
    }
}

const fetchIngressType = async function() {
    try {
        let response = await axios.get(API.INGRESS_TYPES, {
            params: {
                get_all_results: true,
            },
        })
        return response.data
    } catch (error) {
        return error
    }
}

const fetchEgressType = async function() {
    try {
        let response = await axios.get(API.EGRESS_TYPES, {
            params: {
                get_all_results: true,
            },
        })
        return response.data
    } catch (error) {
        return error
    }
}

export default {
    posDailyCash,
    posCashMovement,
    posDailyCashClose,
    dailyInvoices,
    fetchIngressType,
    fetchEgressType,
}
